import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import {
	getSchedule,
	getWorkerCategories,
	getWorkers,
	getWorkStatuses,
	postWorkSchedule,
	postDaysBid,
	getDaysBid
} from './API'

import { getCurrentDate, getDaysInMonth } from './utils'
import WorkScheduleTable from './Table/WorkScheduleTable'

const WorkSchedule = ({ jwt }) => {
	const mobileSize = 1200

	const [selectedDate, setSelectedDate] = useState(getCurrentDate());
	const [schedule, setSchedule] = useState();
	const [statuses, setStatuses] = useState([])
	const [workers, setWorkers] = useState([])
	const [workerCategories, setWorkerCategories] = useState([]);

	const [daysBid, setDaysBid] = useState(0);
	const [originalDaysBid, setOriginalDaysBid] = useState(0);

	const [currentMonthDays, setCurrentMonthDays] = useState()
	const [formattedDate, setFormattedDate] = useState('');
	const [isMobile, setIsMobile] = useState(
		window.screen.width - mobileSize <= 0
	);

	const handleGetSchedule = async (date) => {
		setSchedule((await getSchedule(jwt, date)) ?? [])
	}

	useEffect(() => {
		async function DidMount() {
			setStatuses((await getWorkStatuses(jwt)) ?? []);
			setWorkers((await getWorkers(jwt)) ?? []);
			setWorkerCategories((await getWorkerCategories(jwt)) ?? [])

			setSelectedDate(selectedDate);
			setCurrentMonthDays(getDaysInMonth(selectedDate));
			await handleGetSchedule(selectedDate);

			try {
				const monthStr = selectedDate.substring(0, 7);
				const normData = await getDaysBid(jwt, monthStr);
				const bid = normData.bid || 0;
				setDaysBid(bid);
				setOriginalDaysBid(bid);
			} catch (error) {
				console.error('Ошибка загрузки нормы дней:', error);
				setDaysBid(0);
				setOriginalDaysBid(0);
			}
		}
		DidMount();
		window.addEventListener('resize', function (event) {
			setIsMobile(this.document.body.clientWidth - mobileSize <= 0)
		})
	}, [])

	const handleSchedulePost = async (date) => {
		await postWorkSchedule(jwt, { date: date })
		await handleGetSchedule(date);
	}

	useEffect(() => {
		if (!selectedDate)
			return;

		const dateParts = selectedDate.split('-')
		const month = dateParts[1]
		const year = dateParts[0]
		setCurrentMonthDays(getDaysInMonth(selectedDate))
		setFormattedDate(`${month}-${year}`)
		async function loadNormForMonth() {
			try {
				const monthStr = selectedDate.substring(0, 7);
				const normData = await getDaysBid(jwt, monthStr);
				const bid = normData.bid || 0;
				setDaysBid(bid);
				setOriginalDaysBid(bid);
			} catch (error) {
				console.error('Ошибка загрузки нормы дней:', error);
				setDaysBid(0);
				setOriginalDaysBid(0);
			}
		}
		loadNormForMonth();
	}, [selectedDate])

	const content =
		!schedule || schedule.length <= 0 ? (
			<>
				<h2>На данный месяц графика работ нет. Хотите создать?</h2>
				<Button onClick={() => handleSchedulePost(selectedDate)}>Создать график</Button>
			</>
		) : (
			<WorkScheduleTable
				jwt={jwt}
				selectedDate={selectedDate}
				schedule={schedule}
				workers={workers}
				statuses={statuses}
				isMobile={isMobile}
				currentMonthDays={currentMonthDays}
				workerCategories={workerCategories}
			/>
		)

	return (
		<div style={{ margin: '40px auto', maxWidth: '1440px' }}>
			<h1 style={{ textAlign: 'center' }}>График работы </h1>

			<div className="d-flex gap-3 mb-3 align-items-end">
				<Form.Group style={{ flex: '1' }}>
					<Form.Label htmlFor='month'>Выберите месяц</Form.Label>
					<Form.Control
						type='date'
						id='month'
						value={selectedDate}
						onChange={e => {
							setSelectedDate(e.target.value)
							handleGetSchedule(e.target.value)
						}}
					/>
				</Form.Group>

				<Form.Group style={{ width: '150px' }}>
					<Form.Label htmlFor='daysNorm'>Норма дней</Form.Label>
					<div className="d-flex gap-1">
						<Form.Control
							type='number'
							id='daysNorm'
							min="0"
							max="31"
							value={daysBid}
							onChange={e => {
								const newValue = Number(e.target.value);
								setDaysBid(newValue);
							}}
						/>
						<Button
							variant={originalDaysBid !== daysBid ? "success" : "outline-secondary"}
							disabled={originalDaysBid === daysBid}
							onClick={async () => {
								try {
									const monthStr = selectedDate.substring(0, 7); // "yyyy-MM"
									await postDaysBid(jwt, monthStr, daysBid);
									setOriginalDaysBid(daysBid);
									alert('Норма дней сохранена');
								} catch (error) {
									alert('Ошибка сохранения нормы дней');
								}
							}}
							title={originalDaysBid === daysBid ? "Норма не изменена" : "Сохранить"}
						>
							✓
						</Button>
					</div>
				</Form.Group>
			</div>
			<h1 style={{ textAlign: 'center' }}>{formattedDate}</h1>
			{content}
		</div>
	)
}

export default WorkSchedule